import React from 'react';
import { Button, Typography, ButtonProps, useTheme } from '@material-ui/core';

import { useStyles } from './styles';

interface ICardButton extends ButtonProps {
  title: string;
  value: number;
  isSelected?: boolean;
}

const CardButton: React.FC<ICardButton> = ({
  title,
  value,
  isSelected = false,
  ...rest
}) => {
  const classes = useStyles();
  const theme = useTheme();

  return (
    <Button
      className={classes.container}
      style={{
        backgroundColor: isSelected ? theme.palette.primary.main : '#9DA5B1',
      }}
      {...rest}
    >
      <div className={classes.labelsContainer}>
        <div className={classes.titleContainer}>
          <Typography
            variant="h3"
            className={classes.title}
            style={{ color: theme.palette.common.white }}
          >
            {title}
          </Typography>
        </div>
        <div className={classes.valueContainer}>
          <Typography
            variant="body1"
            className={classes.value}
            style={{ color: theme.palette.common.white }}
          >
            {value}
          </Typography>
        </div>
      </div>
    </Button>
  );
};

export default CardButton;
